<template>
    <div class="list-group-item border-0 d-flex gap-3 py-3 align-items-center">
        <img class="rounded-circle flex-shrink-0" :src="collaborator?.profile_photo" :alt="collaborator?.name"
            width="32" height="32" />
        <div class="d-flex gap-2 w-100 flex-wrap justify-content-between">
            <div>
                <h6 class="mb-0">{{ collaborator?.email }}</h6>
                <!-- <p class="mb-0 opacity-75"></p> -->
            </div>
            <small class="opacity-50 text-nowrap">{{ collaborator?.invite == true ? 'Invite Pending' : `Viewed: ${collaborator?.last_viewed}` }}</small>
        </div>
        <CollaboratorAction
            :collaborator="collaborator"
            @update:permission="e => { collaborator.permission = newPermission = e }"
            @deleted="e => {$emit('deleted', e)}"
            :markup="markup"
        />
    </div>
</template>

<script>
import CollaboratorAction from './CollaboratorAction.vue';

export default {
    components: { CollaboratorAction },
    props: ["collaborator", "markup"],
    emits: ["deleted"],
    data() {
        return {
            newPermission: "view",
        };
    }
}
</script>
